import { useQuery } from "@tanstack/react-query";
import {
  PositionSearchParams,
  positionSearch,
} from "common/api/sakusas/sakusas_position";
import { QUERY_KEYS } from "constant/react_query";

export const useSakusasPositionSearch = (
  searchParams?: PositionSearchParams
) => {
  const { data: position } = useQuery(
    [QUERY_KEYS.SAKUSAS_VIDEO_SEARCH, searchParams],
    async () => {
      const result = await positionSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof position !== "undefined" && position !== "" ? position : null;
  return result;
};
